module.exports = __webpack_public_path__ + "img/wbicon-huangpu.bdc41922.jpg";